import {
  IconHome,
  IconUser,
  IconBriefcase,
  IconMail,
} from "@tabler/icons-react";

export const dockItems = [
  { title: "Home", icon: <IconHome />, href: "#home" },
  { title: "About", icon: <IconUser />, href: "#about" },
  { title: "Projects", icon: <IconBriefcase />, href: "#projects" },
  { title: "Contact", icon: <IconMail />, href: "#contact" },
];
